<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import ImportTemplate from "@/views/components/common/form/officesImportTemplate.vue";
let customerId = window.localStorage.getItem("customerId");
import config from "@/../config";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "offices",
        key: "id",
        url: {
          list: `/admin/system/desk/list`,
          del: "/admin/system/desk",
        },
        output: false,
        qrCode: "qrCode",
      },
      menus: [],
      actions: [
        {
          label: "新增科室",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "system/offices/add",
        },
        {
          label: "导入科室",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "system/offices/import",
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/offices/download",
          type: "info",
        },
        {
          label: "导出标签",
          icon: "md-cloud-download",
          type: "info",
          onClick: this.downloadCodeImg,
          auth: "system/offices/downloadCodeImg",
        },
        {
          label: "批量同步二维码",
          icon: "ios-cloud-done-outline",
          onClick: this.torefall,
          auth: "",
          type: "info",
        },
        // {
        //   label: "常用楼宇楼层",
        //   icon: "ios-home-outline",
        //   onClick: this.tobuildfloor,
        //   auth: "",
        //   type: "info",
        // },
        // {
        //     label: "同步企业微信科室",
        //     icon: "ios-cloud-done-outline",
        //     onClick: this.toreoffice,
        //     auth: "",
        //     type: "info",
        // },
      ],
      filters: [
        {
          label: "科室",
          name: "deskName",
          value: "",
          KeyEnter: this.search,
          type: "selectsearch",
          dropList: [],
          remoteMethod: this.deskChange,
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        // {
        //   title: "序号",
        //   key: "id",
        //   minWidth: 80,
        //   align: "left",
        // }

        {
          title: "楼宇",
          key: "building",
          minWidth: 80,
          align: "center",
        },
        {
          title: "楼层",
          key: "address",
          minWidth: 80,
          align: "center",
        },
        // {
        //   title: "房间号",
        //   key: "deskRoom",
        //   minWidth: 80,
        //   align: "center",
        // },
        {
          title: "所属部门",
          key: "department",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.department;
            if (text == 0) {
              return <span>急诊</span>;
            } else if (text == 1) {
              return <span>门诊</span>;
            } else if (text == 2) {
              return <span>住院</span>;
            } else if (text == 3) {
              return <span>医技</span>;
            } else if (text == 4) {
              return <span>行政</span>;
            }
          },
        },
        {
          title: "科室",
          key: "deskFather",
          minWidth: 120,
          align: "left",
        },
        {
          title: "子科室",
          key: "deskName",
          minWidth: 120,
          align: "left",
          // tree: true,
        },

        {
          title: "电话",
          key: "phone",
          minWidth: 130,
          align: "center",
        },
        {
          title: "负责人",
          key: "principal",
          minWidth: 120,
          align: "center",
        },
        {
          title: "二维码",
          key: "qrCode",
          minWidth: 80,
          align: "center",
          viewimage: true,
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/offices/ref" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toref(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  同步
                </Button>
              );
            },
            "edit",
            "delete",
          ],
          auth: {
            edit: "system/offices/edit",
            del: "system/offices/delete",
          },
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
    // this.loadFiltersFieldDrop('community', 'community_id')
  },
  methods: {
    //搜索
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api
            .load(`/admin/system/desk/selectList`, q, "get")
            .then((res) => {
              const list = res.rows.map((item) => {
                return {
                  value: item.deskName,
                  name: item.deskName,
                };
              });
              // let dropList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
              for (let index = 0; index < this.filters.length; index++) {
                const element = this.filters[index];
                if (element && element.name == "deskName") {
                  this.filters[index]["dropList"] = list;
                }
              }
            });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    handleSelect(selected) {
      let ids_arr = [];
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
        arry.push(element[this.table.qrCode]);
      }
      this.selected = ids_arr.join(",");
      this.arrys = arry;
    },
    loadIMage(image) {
      return new Promise(function (resolve, reject) {
        try {
          image.onload = function () {
            resolve();
          };
        } catch (e) {
          reject();
        }
      });
    },
    async downloadCodeImg() {
      if (this.arrys == null) $utils.toast.warn("请选择需要导出标签");
      // this.msg('请选择数据')
      const arry = this.arrys;
      for (var j = 0; j < arry.length; j++) {
        if (arry[j].indexOf("http") === -1) {
          arry[j] = config.IMAGE_HOST + arry[j];
        }
      }
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let date = nowDate.getDate();
      var blogTitle = "科室二维码标签" + year + month + date;
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = ['http://weixiu.kafukeji.com/admin/profile/upload/code/GK21112200028.png', ];
      // 下载后图片的文件名，个数应与arr对应
      // var imgNameList = ['图片1', '图片2', '图片3'];
      for (var i = 0; i < arry.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.src = arry[i];
        await this.loadIMage(image);
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);

        let url = canvas.toDataURL(); // 得到图片的base64编码数据
        canvas.toDataURL("image/png");

        baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
        if (baseList.length === arry.length && baseList.length > 0) {
          for (let k = 0; k < baseList.length; k++) {
            imgs.file(
              arry[k].substring(arry[k].lastIndexOf("/") + 1, arry[k].length),
              baseList[k],
              { base64: true }
            );
          }
          zip.generateAsync({ type: "blob" }).then(function (content) {
            // see FileSaver.js
            FileSaver.saveAs(content, blogTitle + ".zip");
          });
        }
      }
    },
    //同步
    toref(currentRow) {
      this.id = currentRow.id;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/desk/refresh/${this.id}`)
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success("同步成功");
            setTimeout(() => {
              $utils.url.go(0);
            }, 300);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    async toreoffice() {
      let res = await $utils.api.load(
        `/admin/system/desk/synchronizationDesk`,
        "",
        "GET"
      );
      try {
        if (res.code == 200) {
          this.search();
        }
      } catch (e) {
        $utils.toast.error("同步异常" + e.message);
      }
    },
    tobuildfloor() {
      $utils.url.push({
        name: "offices_building_list",
      });
    },
    torefall() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要同步二维码的科室");
        return true;
      }
      this.id = this.selected;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/desk/refreshBatch/${this.id}`, "", "GET")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success(res.msg);
            if (res.msg) {
              setTimeout(() => {
                $utils.url.go(0);
              }, 500);
            }
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/desk/template/download`;
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api
        .load(`/admin/system/desk/selectList/?isParent=${"0"}`, q)
        .then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.deskName;
              xx.name = element.deskName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskName") {
                this.filters[index]["dropList"] = dropList;
              }
            }
          }
        });
    },
    toAdd() {
      $utils.url.push({ name: "offices_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "offices_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
  },
};
</script>
<style scoped></style>
